import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export type WithElementRef<T, E extends HTMLElement = HTMLElement> = T & {
	ref?: E | null;
};

export type WithoutChildren<T> = T extends any ? Omit<T, "children"> : never;

export type WithoutChild<T> = T extends any ? Omit<T, "child"> : never;

export type WithoutChildrenOrChild<T> = WithoutChild<WithoutChildren<T>>;
